<template>
  <div>
    <a-card class="order-detail-content">
      <div class="order-detail-title-border">
        <div class="order-detail-content-title">{{ $t('transportInfo') }}</div>
        <dol-button v-if="elBoxList.length > 0" @click="openSelectTemplate(orderForm.CITY_ID, orderForm.D_CITY_ID)">
          <a-icon type="plus"/>
        </dol-button>
      </div>
      <div class="transport-list-box" v-if="elTransportList?.length > 0">
        <div class="transport-list__take__city">{{ $t('takeBoxPlace') }} - <span>{{ $dt(orderForm, 'CITY_NAME') }}</span></div>
        <div style="display: flex;margin-bottom: 24px;">
          <template v-for="item in elTransportList">
            <transport-tree ref="transTree" :obj="item" :master-id="orderForm.MASTER_ID" :order-form="orderForm"
                            :xc-sheet-code="orderForm.SHEET_CODE" @editTrans="editTrans" @delNode="delNode" @addFollowUp="addFollowUp" @openBoxModel="openBoxModel" @getOrderDetail="getOrderDetail"  @editBox="editBox"></transport-tree>
          </template>
        </div>
        <div class="transport-list__take__city">{{ $t('通用_还箱地') }} - <span>{{ $dt(orderForm, 'D_CITY_NAME') }}</span></div>
      </div>
      <div style="display: flex" v-else>
        <div class="transport-add">
          <a-space :size="80">
            <a-button @click="openSelectTemplate(orderForm.CITY_ID, orderForm.D_CITY_ID)"
                      class="transport-select-button">
              <img src="../../../public/static/icon/selectTemplate.svg"/>
              <div class="transport-select-button-text">{{ $t('selectRouteTemplate') }}</div>
            </a-button>
            <a-button class="transport-add-button" @click="addNodeManually">
              <a-icon class="transport-add-button-icon" type="plus-circle"/>
              <div class="transport-add-button-text" >{{ $t('manuallyAddNode') }}</div>
            </a-button>
          </a-space>
        </div>
      </div>
    </a-card>
    <!-- 运输信息编辑 -->
    <a-modal v-model.trim="transportShow" centered width="60%" :okText="$t('confirm')" :cancelText="$t('cancel')"
             :title="$t('transportInfo')" destroyOnClose @ok="saveTransport"
             @cancel="transForm= {}">
      <dol-form-model :model="transForm" :rules="transValidateRules" ref="transForm">
        <a-row>
          <a-col :span="11">
            <a-form-model-item :label="$t('startingPoint')" :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                               prop="CITY_ID">
              <dol-select
                style="margin-right: 10px"
                v-model="transForm.NATION"
                source="server"
                server-type="DotNet"
                dot-net-table-name="BM_BASE_CODE"
                :label-field="$kt('CODE_NAME')"
                key-field="CODE_ID"
                value-field="CODE_ID"
                :query-data="$api.baseCode['10000006']"
                :disabled="nodeDisabled"
                @change="transForm.CITY_ID = ''"
                width="48%"
              />
              <dol-select
                v-model="transForm.CITY_ID"
                source="server"
                server-type="DotNet"
                dot-net-table-name="GM_CITY"
                :label-field="$kt('CITY_NAME')"
                key-field="CITY_ID"
                value-field="CITY_ID"
                :disabled="nodeDisabled"
                ref="city"
                :query-data="queryDataNation"
                width="48%"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="11" offset="2">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('destination')"
                               prop="D_CITY_ID">
              <dol-select
                style="margin-right: 10px"
                v-model="transForm.D_NATION"
                source="server"
                server-type="DotNet"
                dot-net-table-name="BM_BASE_CODE"
                :label-field="$kt('CODE_NAME')"
                key-field="CODE_ID"
                value-field="CODE_ID"
                :query-data="$api.baseCode['10000006']"
                @change="transForm.D_CITY_ID = ''"
                width="48%"
              />

              <dol-select
                v-model="transForm.D_CITY_ID"
                source="server"
                server-type="DotNet"
                dot-net-table-name="GM_CITY"
                :label-field="$kt('CITY_NAME')"
                key-field="CITY_ID"
                value-field="CITY_ID"
                ref="city"
                :query-data="queryDataRNation"
                width="48%"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item :label="$t('startingQuay')" :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="SW_ID">
              <dol-select
                v-model.trim="transForm.SW_ID"
                source="server"
                server-type="DotNet"
                :dot-net-table-name="wharfSql"
                :dot-net-table-type="2"
                :dot-net-columns="false"
                dotNetReturnListField="DATA_LIST"
                :label-field="$kt('SW_NAME')"
                key-field="SW_ID"
                value-field="SW_ID"
                :disabled="nodeDisabled"
                :query-data="queryDataSw"
                width="100%"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="11" offset="2">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('terminalWharf')"
                               prop="D_SW_ID">
              <dol-select
                v-model.trim="transForm.D_SW_ID"
                source="server"
                server-type="DotNet"
                :dot-net-table-name="wharfSql"
                :dot-net-table-type="2"
                :dot-net-columns="false"
                dotNetReturnListField="DATA_LIST"
                :label-field="$kt('SW_NAME')"
                key-field="SW_ID"
                value-field="SW_ID"
                :query-data="queryRDataSw"
                width="100%"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item :label="$t('transportationType')" :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                               prop="SHIP_TYPE">
              <a-radio-group v-model.trim="transForm.SHIP_TYPE">
                <template v-for="item in transTypeList">
                  <a-radio :value="item.code">
                    {{ $dt(item, 'text') }}
                  </a-radio>
                </template>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" offset="2">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('uploadFiles')"
                               v-if="!transForm.GUID_CODE"
                               prop="GUID_CODES">
              <dol-upload @finished="transFinished" :paramsData="transParamsData" :text="$t('uploadFiles')"
                          serverType="2009" v-model.trim="transForm.GUID_CODES"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item
              :label="transForm.SHIP_TYPE === '20061001' || transForm.SHIP_TYPE === '20061003' ? $t('BLNO') : $t('sweepNumber') "
              :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="SHIP_CODE">
              <a-input v-model.trim="transForm.SHIP_CODE"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="transForm.SHIP_TYPE === '20061001' || transForm.SHIP_TYPE === '20061003'" :span="11"
                 :offset="2">
            <a-form-model-item :label="$t('vesselVoyage')" :labelCol="{span: 24}"
                               :wrapperCol="{span: 24}" prop="SHIP_NAME">
              <a-auto-complete
                v-model.trim="transForm.SHIP_NAME"
                @select="getShipName"
                @change="getShipNameList"
              >
                <template slot="dataSource">
                  <a-select-opt-group v-if="shipNameList.length>0" :key="1">
                              <span slot="label">
                                    <a-pagination style="position: absolute;right: 4px" v-model.trim="current"
                                                  :total="total"
                                                  show-less-items @change="getShipNameList"/>
                              </span>
                    <a-select-option v-for="name in shipNameList" :key="name">
                      {{ name }}
                    </a-select-option>
                  </a-select-opt-group>
                </template>
              </a-auto-complete>
            </a-form-model-item>
          </a-col>
        </a-row>
      </dol-form-model>
    </a-modal>
    <a-modal
        v-model="boxShowModel"
        centered
        :footer="null"
    >
      <div>
        <a-tag v-for="(item,index) in elBoxList" :key="index">{{item}}</a-tag>
      </div>
    </a-modal>

    <a-modal
      v-model="editBoxModel"
      centered
      @ok="saveTransport"
      @cancel="closeTrans"
    >
      <div>
        <a-row>
          <a-col>
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="SHIP_DETAIL">
              <template #label>
                <span>{{ $t('pleaseSelectTheCaseNumber') }}</span>
                <a-checkbox @change="checkAllTrans">{{ $t('selectAll') }}</a-checkbox>
              </template>
              <div style="border: 1px solid #eeeeee;border-radius: 4px;padding: 10px 20px;line-height: 1;">
                <a-checkbox-group v-model.trim="transForm.SHIP_DETAIL" :options="boxOptions"></a-checkbox-group>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
    </a-modal>

  </div>
</template>

<script>
import sheetScript from "@/views/order/orderDetailScript/sheetScript";
import transportTree from "@/components/common/transportTree";
export default {
  name: "cargoTransport",
  mixins: [sheetScript],
  components: {transportTree},
  props: {
    elTransportList: {type: Array,default: []},
    elBoxList: {type: Array,default: []},
    transTypeList: {type: Array,default: []},
    orderForm: {type: Object,default: {}}
  },
  data() {
    return {
      current: 1,
      total: 0,
    }
  },
  computed:{
    queryDataNation() {
      return {nation: this.transForm?.NATION}
    },
    queryDataRNation() {
      return {nation: this.transForm?.D_NATION}
    },
    queryDataSw() {
      return {'A.CITY_ID': this.transForm?.CITY_ID}
    },
    queryRDataSw() {
      return {'A.CITY_ID': this.transForm?.D_CITY_ID}
    },
  },
  methods: {
    getOrderDetail(masterId) {
      this.$emit('getOrderDetail', masterId)
    },
    saveTransport() {
      let file;
      if (this.transForm.GUID_CODES && this.transForm.GUID_CODES instanceof Array) {
        file = this.transForm.GUID_CODES.map(item => {
          if (typeof item === 'object') {
            return item.GUID_CODE;
          } else {
            return item;
          }
        }).join(',');
      } else {
        file = this.transForm.GUID_CODES;
      }
      let data = {
        "SHIP_ID": this.transForm.SHIP_ID,
        "XC_MASTER_ID": this.orderForm.MASTER_ID,
        "XC_SHEET_CODE": this.orderForm.SHEET_CODE,
        "CITY_ID": this.transForm.CITY_ID,
        "D_CITY_ID": this.transForm.D_CITY_ID,
        "SW_ID": this.transForm.SW_ID,
        "D_SW_ID": this.transForm.D_SW_ID,
        "SHIP_TYPE": this.transForm.SHIP_TYPE,
        "SHIP_NAME": this.transForm.SHIP_NAME,
        "SHIP_CODE": this.transForm.SHIP_CODE,
        "PARENT_SHIP_ID": this.transForm.PARENT_SHIP_ID,
        "BOX_CODES": this.transForm.SHIP_DETAIL?.join(),
        "GUID_CODES": file
      }
      this.$h5Api({
        type: '4071',
        data: [data],
      }).then(({data}) => {
        this.boxOptions = []
        this.transForm = {}
        this.getOrderDetail(this.$route.query.MASTER_ID);
        this.transportShow = false
        this.editBoxModel = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.order-detail-content {
  margin-bottom: 12px;

  .order-detail-content-title {
    font-size: 24px;
    font-weight: 600;
    color: #FF3D27;
  }

  .user-box-hint {
    width: 100%;
    background: rgba(255,119,0,0.06);
    border-radius: 4px;
    padding: 14px 26px 14px 18px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    .user-box-hint-label {
      width: 85%;
      font-weight: 400;
      color: #888888;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        font-weight: 600;
        color: #FF7700;
      }

      a{
        color: #1F6CBA;
      }
    }
  }
  .hand-box-hint {
    width: 100%;
    background: #F8F8F8;
    border-radius: 4px;
    padding: 14px 26px 14px 18px;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;

    .hand-box-hint-label {
      width: 85%;
      font-weight: 400;
      color: #888888;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        font-weight: 600;
        color: #666666;
      }

      a{
        color: #1F6CBA;
      }
    }
  }

  .order-detail-content-main {
    display: flex;
    justify-content: space-between;

    .order-detail-content-code {
      color: #333333;
      font-weight: 600;
      line-height: 1;
    }

    .order-detail-content-day {
      color: #333333;
      margin-top: 16px;
      font-weight: 600;
      line-height: 1;

      span {
        color: #999999;
      }
    }

    .order-detail-content-pay_button {
      color: #1F6CBA;
    }
  }

  .dol-row {
    height: 100%;
    margin: 0;
    overflow: hidden;
    display: flex;
  }

  .order-detail-content-border {
    background: #F8F8F8;
    padding: 12px 0;
    margin-top: 12px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .order-detail-content-left {
      .order-detail-content-date {
        padding: 0 6px;
      }

      .order-detail-content-city {
        margin-left: 5px;
        font-weight: 600;
        color: #333333;
      }

      .order-detail-content-box {
        margin-top: 5px;
        margin-left: 10px;
        color: #666666;
      }
    }

    .order-detail-content-mid {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
    }

    .order-detail-content-status {
      font-size: 14px;
      font-weight: 400;
      color: #FA8C16;
    }

    .order-detail-content-button {
      display: flex;
      justify-content: flex-end;
      margin-right: 10px;

      .order-detail-content-button-dropdown {
        text-align: center;
        border: none;
        background-color: #F8F8F8;
        font-size: 32px;
        margin-bottom: 32px;
      }
    }
  }

  .order-detail-title-border {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .order-detail-content-title {
      font-size: 18px;
      margin-bottom: 0;
      font-weight: 700;
      line-height: 1;
      color: #333333;
    }

    .order-detail-content-add_button {
      display: flex;
      align-items: center;
      border-radius: 2px;
      border: 1px solid #1F6CBA;
      padding: 6px 10px;
      color: #1F6CBA;
      font-size: 12px;
    }
  }

  .order-detail-transport-content {
    display: flex;
    flex-wrap: wrap;

    .ant-row {
      margin-top: 12px;
    }

    .order-detail-transport-content_border {
      border-radius: 4px;
      border: 1px solid #D9D9D9;
      padding: 12px;

      .order-detail-transport-ship_name {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .order-detail-transport-ship_box {
          font-weight: 600;
          color: #333333;
        }
      }

      .order-detail-transport-box-code {
        font-size: 12px;
        color: #333333;
        margin-top: 6px;
      }

      .order-detail-transport-box-shift {
        font-size: 12px;
        color: #333333;
        margin-top: 4px;
      }

      .order-detail-transport-box-shift-code {
        display: flex;
        flex-wrap: wrap;
        margin-top: 5px;

        .shift-code {
          margin: 3px 8px 6px 0px;
          padding: 3px 13px 2px 13px;
          background: #F8F8F8;
          border-radius: 11px;
          font-size: 12px;
          color: #666666;
        }
      }
    }
  }

  .account-table {
    width: 100%;
    margin-top: 12px;
    thead {
      background: #FAFAFA;
      font-size: 14px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);

      tr th {
        padding: 12px 8px;
      }
    }

    .account-table-body {
      .account-item-header {
        td {
          background: #FAFAFA;;
          padding: 12px 8px;
          border-radius: 10px 10px 0 0;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          background: #FAFAFA;
          border: 1px solid #D9D9D9;
        }
      }

      .account-item-content {
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);

        .account-item-content__img__box {
          display: flex;
          align-items: center;

          .account-item-content__img__box__info {
            margin-left: 10px;

            .account-item-content__box__info__code {
              margin-bottom: 8px;
            }

            .account-item-content__box__info__size {
              color: #999999;
              font-size: 14px;
            }
          }

        }

        td {
          padding: 12px 8px;
          border: 1px solid #F5F7F9;;
        }
      }
    }

    .account-table-body-not {
      .account-item-header {
        td {
          background: #F5F7F9;;
          padding: 10px 20px;
          border-radius: 10px 10px 0 0;
        }
      }

      .account-item-content {
        td {
          padding: 12px 8px;
          border: 1px solid #F5F7F9;;
        }
      }
    }
  }

  .transport-list-box {
    margin-top: 12px;
    display: flex;
    flex-direction: column;

    .transport-list__take__city {
      text-align: center;
      padding: 14px 0;
      width: 100%;
      border-radius: 5px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(221, 221, 221, 1);

      span {
        font-size: 18px;
        font-weight: 700;
        color: rgba(0, 0, 0, 1);
      }
    }
  }

  .transport-add {
    margin: auto;
    margin-top: 16px;

    .transport-select-button {
      padding: 24px 33px 90px 33px;
      opacity: 1;
      border-radius: 5px;
      background: rgba(31, 108, 186, 1);

      .transport-select-button-text {
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        margin-top: 16px;
      }
    }

    .transport-add-button {
      padding: 24px 33px 90px 33px;
      border-radius: 5px;
      border: 1px solid rgba(31, 108, 186, 1);

      .transport-add-button-icon {
        font-size: 20px;
        color: rgba(31, 108, 186, 1);
      }

      .transport-add-button-text {
        font-size: 16px;
        font-weight: 500;
        color: rgba(31, 108, 186, 1);
        margin-top: 16px;
      }
    }
  }

  .order-detail-collapse{
    margin-top: 20px;
    padding: 14px 60px 16px 16px;
    background: #F8F8F8;
    border-radius: 4px;
    align-items: center;
    position: relative;
    .order-detail-collapse-left {

      .order-detail-collapse-yard {
        margin-top: 5px;
        color: #666666;
      }

      .order-detail-collapse-code {
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }
    }

    .order-detail-collapse-date {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #666666;
    }

    .order-detail-collapse-box {
      color: #333333;
      display: flex;
      align-items: center;
      .order-detail-collapse-box_num{
        font-size: 20px;
        font-weight: 600;
      }
    }

    .order-detail-collapse-mid {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
    }

    .order-detail-collapse-status {
      font-size: 14px;
      font-weight: 400;
      .order-detail-collapse-status_take{
        font-weight: 600;
        color: #666666;  display: flex;
        align-items: center;
        .order-detail-collapse-status_take_circle{
          width: 8px;
          height: 8px;
          background: #52C41A;
          border-radius: 50%;
          margin-right: 8px;
        }

        order-detail-collapse-status_wait_circle{
          width: 8px;
          height: 8px;
          background: #FF4D4F;
          border-radius: 50%;
          margin-right: 8px;
        }

      }
      .order-detail-collapse-status_ret{
        font-weight: 600;
        color: #666666;  display: flex;
        align-items: center;
        .order-detail-collapse-status_ret_finish_circle{
          width: 8px;
          height: 8px;
          background: #52C41A;
          border-radius: 50%;
          margin-right: 8px;
        }

        .order-detail-collapse-status_ret_wait_circle{
          width: 8px;
          height: 8px;
          background: #FF4D4F;
          border-radius: 50%;
          margin-right: 8px;
        }

        .order-detail-collapse-status_ret_reting_circle{
          width: 8px;
          height: 8px;
          background: #FFAD09;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }

    .order-detail-collapse-button {
      display: flex;

      .order-detail-content-button-dropdown {
        text-align: center;
        border: none;
        background-color: #F8F8F8;
        font-size: 32px;
        margin-bottom: 32px;
      }
    }

    .order-detail-collapse-box_return_num{
      font-size: 20px;
      font-weight: 600;
      color: #333333;
    }
  }

  .order-detail-content-take{
    padding: 20px;
    background-color: #F5F7F9;
    border-top: 1px solid #EEEEEE;
    .order-detail-content-take_title{
      color: #666666;
    }
    .collapse-dol-list{
      margin-top: 10px;
      background: rgba(255,255,255,0.8);
      th{
        background: rgba(255,255,255,0.8);
      }
      .box_img{
        height: 48px;
        width: 48px;
        margin-right: 24px;
      }
      .box_code{
        font-size: 12px;
        font-weight: 600;
        color: #3093F7;
        background: #E6F7FE;
        border: 1px solid #3093F7;
      }
    }
    .ant-table-body{
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      th{
        font-weight: 600;
        color: #333333;
      }
    }
  }
}


</style>
